import React, { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import Loader from '../CommonElements/Loader';
import LayoutRoutes from './LayoutRoutes';

const Routers = () => {
  return (
    <BrowserRouter basename="/">
      <Suspense fallback={<Loader />}>
        <LayoutRoutes />
      </Suspense>
    </BrowserRouter>
  );
};

export default Routers;
